import React, { useCallback, useEffect, useState } from "react";
import { MdTrendingFlat } from "react-icons/md";
import { FaLock, /* FaSlidersH ,*/ FaTimes, FaSpinner } from "react-icons/fa";
import { Alert, Card } from "react-bootstrap";
import { debounce } from "debounce";
import PulseLoader from "react-spinners/PulseLoader";
import he from "he";
import { Button, Pagination, Range } from "../../components";
import { SORT_MAP, STYLES } from "../../constants";
// import Search from "./Search";
import FilterSection from "./FilterSection";
import FilterInfo from "./FilterInfo/FilterInfo";
import { clearQuery, getQuery, setQuery } from "../../utils/history";
import api from "../../api";
import {
  FILTER,
  hasAccess,
  generateFiltersInfo,
  getAllFiltersQuantity,
  getDefaultQuery,
  getQueryArray,
  getRangeDefaultValue,
  getRating
} from "../../utils/searchPage";
import S from "./Styles";
import { isMob } from "../../utils/common";
import config from "../../utils/config";

let query = getDefaultQuery(getQuery());

//FIXME Should we replace from WWTT to GBG

const adjustURL = url => he.decode(url);

function SearchPage() {
  const [filterOpened, setFilterOpened] = useState(true);
  const [filterInfo, setFilterInfo] = useState(generateFiltersInfo(query));
  const [filterDefaults, setFilterDefaults] = useState(null);
  const [subOpened, setSubOpened] = useState(query[FILTER.id.subOpened]);

  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const [pager, setPager] = useState({
    last_page: null,
    last_page_url: "",
    next_page_url: "",
    path: "",
    per_page: null,
    prev_page_url: null,
    to: null,
    total: null,
    from: null,
    current_page: null,
    first_page_url: ""
  });

  const getListingsCallback = useCallback(getListings, []);
  const debounceGetListing = debounce(getListings, 400);

  useEffect(() => {
    getListingsCallback(query, true);
  }, [getListingsCallback]);

  async function getListings(query) {
    try {
      setError(false);
      setSuccess(false);
      setLoading(true);
      const res = await api.getListings(query);
      setLoading(false);
      setListings(res.data);
      setSuccess(true);
      const { data, ...paginationData } = res;
      setPager(paginationData);
    } catch (error) {
      setSuccess(false);
      setLoading(false);
      setError(true);
    }
  }
  function updateListings() {
    if (Object.keys(query).length !== 0) {
      setQuery(query);
    } else {
      query = {};
      clearQuery();
    }
    setFilterInfo(generateFiltersInfo(query));
    debounceGetListing(query);
  }
  function handleOpenFilter() {
    setFilterOpened(true);
    setFilterDefaults({ ...query });
  }
  function handleCloseFilter() {
    setFilterOpened(false);
    setQuery(filterDefaults);
    query = { ...filterDefaults };
    setFilterInfo(generateFiltersInfo(filterDefaults));
  }
  function handleApplyFiltersClick() {
    setFilterDefaults(query);
    setFilterOpened(false);
  }
  function handleClearClick(ids) {
    ids.forEach(id => {
      delete query[id];
    });
    setQuery(query);
    setFilterInfo(generateFiltersInfo(query));
    debounceGetListing(query);
  }
  function handleClearFilter() {
    clearQuery();
    query = getDefaultQuery({});
    setFilterInfo(generateFiltersInfo(query));
    debounceGetListing(query);
  }
  // function handleSearch(city) {
  //   if (city.length > 0) {
  //     query[FILTERS_ID.cityName] = city;
  //   } else {
  //     delete query[FILTERS_ID.cityName];
  //   }
  //   updateListings();
  // }
  function handleRangeChange(id, value) {
    query[id] = value;
    updateListings();
  }
  function handleCheckboxChange(e) {
    const { id, value } = e.target.dataset;
    query[id] = getQueryArray(query[id]);

    if (e.target.checked && !query[id].includes(value)) {
      query[id].push(value);
    } else {
      query[id] = query[id].filter(p => p !== value);
    }
    if (query[id].length === 0) {
      delete query[id];
    }
    updateListings();
  }
  function handleSortChange(e) {
    const key = e.target.value;
    query[FILTER.id.order] = [SORT_MAP[key].id, SORT_MAP[key].orderBy];
    updateListings();
  }
  function handlePrevPageClick() {
    query[FILTER.id.page] = pager.current_page - 1;
    updateListings();
  }
  function handleNextPageClick() {
    query[FILTER.id.page] = pager.current_page + 1;
    updateListings();
  }
  function handlePageChange(page) {
    query[FILTER.id.page] = page;
    updateListings();
  }
  function handleMoreClick() {
    setSubOpened(!subOpened);
    query[FILTER.id.subOpened] = !subOpened;
    setQuery(query);
  }
  function handlePremiumClick() {
    const { jQuery } = window;
    if (jQuery) {
      jQuery("#premiumModal").modal("show");
    }
  }
  function renderSorter() {
    return (
      <S.SelectWrap isIcon={isMob} primary={isMob && STYLES.color.black}>
        <select
          className={"mx-2"}
          onChange={handleSortChange}
          value={query.order ? query.order[0] : SORT_MAP.rating.id}
        >
          {Object.keys(SORT_MAP).map((s, i) => (
            <option value={SORT_MAP[s].id} key={i}>
              {SORT_MAP[s].name}
            </option>
          ))}
        </select>
      </S.SelectWrap>
    );
  }
  function renderSection(sections, children) {
    return Object.keys(sections).map(id => {
      let nested = false;
      let hideClearBtn = false;
      let active = isMob ? 0 : 1;
      if (FILTER.section.second[id] || FILTER.section.secondMore[id]) {
        nested = true;
        if (isMob) {
          active = 1;
        }
      }

      if (FILTER.section.first[id]) {
        if (isMob) {
          active = 1;
        }
      }

      if (id === FILTER.id.continents && !config.premiumUser) {
        hideClearBtn = true;
      }
      return (
        <FilterSection
          key={id}
          title={sections[id]}
          tooltipText={config.tooltipTexts[id]}
          active={active}
          disabled={!hasAccess(id)}
          nested={nested}
          filterInfo={
            nested ? (
              undefined
            ) : (
              <FilterInfo
                info={filterInfo[id]}
                onClearClick={
                  hideClearBtn ? null : () => handleClearClick([id])
                }
              />
            )
          }
        >
          {children(id)}
        </FilterSection>
      );
    });
  }
  function renderCheckboxes(id) {
    return Object.keys(FILTER.checkbox[id]).map(key => {
      let checked = query[id] ? query[id].includes(key) : false;
      let disabled = !hasAccess(id);
      let isNotClickable = false;
      let hasLock = false;

      if (key === "northAmerica" && !config.premiumUser) {
        checked = true;
        isNotClickable = true;
      }

      if (
        id === FILTER.id.continents &&
        FILTER.premium[key] &&
        !config.premiumUser
      ) {
        checked = false;
        disabled = true;
        hasLock = true;
      }

      return (
        <div
          className="d-flex align-items-center"
          key={key}
          onClick={disabled ? handlePremiumClick : undefined}
        >
          <S.Checkbox
            id={`checkbox-${key}`}
            label={FILTER.checkbox[id][key]}
            data-id={id}
            data-value={key}
            checked={checked}
            onChange={e => (isNotClickable ? false : handleCheckboxChange(e))}
            disabled={disabled}
          />
          {hasLock && (
            <FaLock
              className="d-inline-block ml-2 lock"
              style={{ color: STYLES.color.grey }}
            />
          )}
        </div>
      );
    });
  }
  function renderRange(id) {
    return (
      <div onClick={!hasAccess(id) ? handlePremiumClick : undefined}>
        <Range
          id={id}
          defaultValue={getRangeDefaultValue(query[id])}
          onAfterChange={value => handleRangeChange(id, value)}
          disabled={!hasAccess(id)}
        />
      </div>
    );
  }
  function renderPagesInfo() {
    if (pager.total) {
      return `${pager.from}... ${pager.to} from ${pager.total} results`;
    }
  }
  return (
    <S.Container>
      <S.Sidebar>
        {/*<section>
          <Search city={query[FILTER_ID.cityName]} onSearch={handleSearch} />
          <hr className="d-none my-4 d-md-block" />
        </section>*/}
        <section className="d-flex d-sm-none text-center mt-3">
          <Button
            className="w-100 px-0 text-uppercase"
            onClick={handleOpenFilter}
            primary={isMob && STYLES.color.black}
          >
            Open FILTERS {getAllFiltersQuantity(query)}
          </Button>
          <Button
            outline
            primary={isMob && STYLES.color.black}
            className="w-100 ml-2 mr-2 px-0"
            onClick={handleClearFilter}
          >
            CLEAR FILTERS
          </Button>
          {renderSorter()}
        </section>
        {/*<section className="mb-4 d-none d-sm-block">
          <S.TextWithIcon>
            <FaSlidersH />
            <b>
              OR USE OUR FILTERS TO FIND <br /> THE BEST CITIES TO VISIT
            </b>
          </S.TextWithIcon>
        </section>*/}
        <S.FilterWrap filterOpened={filterOpened}>
          <S.FilterTopBar className="d-flex d-sm-none align-items-center justify-content-center py-1">
            <b>Filter By</b>
            <FaTimes onClick={handleCloseFilter} />
          </S.FilterTopBar>
          {renderSection(FILTER.section.first, renderCheckboxes)}
          <FilterSection
            title="City Characteristics"
            tooltipText={config.tooltipTexts.cityCharacteristics}
            active={1}
            filterInfo={
              <FilterInfo
                info={filterInfo.cityCharacteristics}
                onClearClick={() => handleClearClick(Object.keys(FILTER.range))}
              />
            }
          >
            {renderSection(FILTER.section.second, renderRange)}
            {!isMob && (
              <div className="text-center">
                <S.ButtonLink
                  className="font-weight-bold"
                  onClick={handleMoreClick}
                >
                  {subOpened ? "Less" : "More"} filters
                </S.ButtonLink>
              </div>
            )}
            {(subOpened || isMob) &&
              renderSection(FILTER.section.secondMore, renderRange)}
          </FilterSection>

          {renderSection(FILTER.section.third, renderCheckboxes)}

          {isMob && (
            <S.ApplyFilter className="text-center p-3">
              <Button
                className="d-flex w-100 align-items-baseline justify-content-center"
                onClick={handleApplyFiltersClick}
                size="lg"
              >
                Show destinations{" "}
                <S.Counter>
                  {loading ? (
                    <FaSpinner className="atv-spin" />
                  ) : (
                    <>({pager.total})</>
                  )}
                </S.Counter>
              </Button>
            </S.ApplyFilter>
          )}
        </S.FilterWrap>
      </S.Sidebar>
      <main className="w-100">
        <div className="d-flex align-items-center flex-wrap mb-4">
          <Button
            onClick={handleClearFilter}
            className="d-none d-sm-inline-block mr-3 text-uppercase"
          >
            Clear Filters
          </Button>
          <div className="d-none d-sm-flex align-items-center text-nowrap mr-auto">
            <span className="d-none d-sm-inline">Sort By:</span>
            {renderSorter()}
          </div>
          <section className="d-none d-sm-block text-muted">
            {renderPagesInfo()}
          </section>
        </div>
        {error && <Alert variant="danger">Something went wrong...</Alert>}
        <section className="position-relative">
          {loading && (
            <S.Loader>
              <PulseLoader color={STYLES.color.blue} size={20} margin={4} />
            </S.Loader>
          )}
          {listings.length > 0 && (
            <>
              <S.Grid>
                {listings.map((c, i) => (
                  <Card key={c.ID}>
                    <a
                      href={adjustURL(c.url)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <S.CardImg
                        variant="top"
                        src={
                          c.image
                            ? c.image
                            : "/wp-content/themes/BusinessDirectory/images/gbg-placeholder.svg"
                        }
                      />
                      {c.has_premium_guide &&
                        c.has_premium_guide.meta_value === "1" && (
                          <S.BadgePremium>Premium Guide</S.BadgePremium>
                        )}
                    </a>
                    <div className="p-2 p-lg-3">
                      <S.TitleLink
                        href={adjustURL(c.url)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {c.post_title}
                      </S.TitleLink>
                      <S.Rating initialRating={getRating(c)} />
                    </div>
                  </Card>
                ))}
              </S.Grid>
              <S.Navigation>
                <section className="mt-3 mb-sm-3 text-center text-lg-left text-muted">
                  {renderPagesInfo()}
                </section>
                <section className="d-lg-flex align-items-center justify-content-between">
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="d-none d-md-block mr-2">Pages:</div>
                    <Pagination
                      className="mb-2 mb-md-0 mt-3 mt-md-0"
                      current={pager.current_page}
                      total={pager.total}
                      pageSize={pager.per_page}
                      onChange={handlePageChange}
                    />
                  </div>
                  <div className="d-none d-md-flex align-items-center justify-content-center">
                    <MdTrendingFlat style={{ transform: "rotate(-180deg)" }} />
                    <S.PagerNav
                      className={"mx-2"}
                      disabled={pager.current_page === 0}
                      onClick={handlePrevPageClick}
                    >
                      Previous
                    </S.PagerNav>
                    <S.PagerNav
                      className={"mx-2"}
                      disabled={pager.last_page === pager.current_page}
                      onClick={handleNextPageClick}
                    >
                      Next
                    </S.PagerNav>
                    <MdTrendingFlat />
                  </div>
                </section>
              </S.Navigation>
            </>
          )}
        </section>
        {success && listings.length === 0 && (
          <Alert variant="info">
            Sorry, but we can’t find a listing that matches your criteria
          </Alert>
        )}
      </main>
    </S.Container>
  );
}

export default SearchPage;
